import {
  CompetenciesCompetencyFilter,
  DataTableFilter,
  FilterType,
} from 'generated/resources/datatable.graphql'
import {
  CompetenciesCompetencyGroupFilterOptionFragment,
  JobCatalogRoleFilterOptionFragment,
} from 'generated/resources/graphql'
import { compact } from 'lodash'

import i18n from 'modules/core/lib/i18n'

export interface CompetenciesFilterOptions {
  jobs: JobCatalogRoleFilterOptionFragment[]
  competencyGroups: CompetenciesCompetencyGroupFilterOptionFragment[]
}

export const competenciesFilters = (
  filterOptions: CompetenciesFilterOptions,
  isCompetenciesRevampEnabled: boolean
): DataTableFilter<CompetenciesCompetencyFilter>[] =>
  compact([
    !isCompetenciesRevampEnabled && {
      identifier: 'competency.job',
      title: i18n.t('competencies_v3.competencies_table.filters.job_role'),
      path: 'roleIds',
      type: FilterType.String,
      categories: [
        {
          kind: 'MultipleChoice',
          operation: 'in',
          options: filterOptions.jobs.map((job) => ({
            value: job.id.toString(),
            label: job.name,
          })),
        },
      ],
      default: true,
    },
    {
      identifier: 'competency.group',
      title: i18n.t('competencies_v3.competencies_table.filters.competency_group'),
      path: 'competencyGroupId',
      type: FilterType.String,
      categories: [
        {
          kind: 'MultipleChoice',
          operation: 'in',
          options: filterOptions.competencyGroups.map((group) => ({
            value: group.id,
            label: group.name,
          })),
        },
      ],
      default: true,
    },
  ])
